var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useImperativeHandle, useState } from 'react';
export function useDefaultAccordionController(ref, _a) {
    var onPanelChanged = _a.onPanelChanged;
    var _b = useState([]), currentOpen = _b[0], setCurrentOpen = _b[1];
    var getIsOpen = useCallback(function (id) {
        return currentOpen.includes(id);
    }, [currentOpen]);
    var setIsOpen = useCallback(function (id) {
        setCurrentOpen(function (open) {
            if (open.includes(id)) {
                var value = open.filter(function (el) { return el !== id; });
                onPanelChanged && onPanelChanged(__spreadArray([], value, true));
                return value;
            }
            onPanelChanged && onPanelChanged(__spreadArray(__spreadArray([], open, true), [id], false));
            return __spreadArray(__spreadArray([], open, true), [id], false);
        });
    }, [onPanelChanged]);
    useImperativeHandle(ref, function () { return ({
        open: function (id) {
            if (!getIsOpen(id)) {
                setCurrentOpen(function (open) {
                    onPanelChanged && onPanelChanged(__spreadArray(__spreadArray([], open, true), [id], false));
                    return __spreadArray(__spreadArray([], open, true), [id], false);
                });
            }
        },
        close: function (id) {
            if (getIsOpen(id)) {
                setCurrentOpen(function (open) {
                    var value = open.filter(function (el) { return el !== id; });
                    onPanelChanged && onPanelChanged(__spreadArray([], value, true));
                    return value;
                });
            }
        },
        closeAll: function () {
            setCurrentOpen([]);
            onPanelChanged && onPanelChanged([]);
        },
    }); }, [getIsOpen, onPanelChanged]);
    return { getIsOpen: getIsOpen, setIsOpen: setIsOpen };
}
//# sourceMappingURL=useDefaultAccordionController.js.map